import React from 'react';
import { useStyletron } from 'baseui';
import { ListItem } from 'baseui/list';
import { Select, SIZE as SelectSize, TYPE as SelectType } from 'baseui/select';
import { LabelMedium } from 'baseui/typography';
import { filterOptionOverrides, listItemOverrides } from '../../side-panel/annotations/annotation-filter';
import type { SearchOptionWithIcon } from '../../side-panel/common';
import { RenderSearchOptionLabel } from '../../side-panel/common';
export type AnnotationFilterIconStyles = {
  size?: string | number;
};
export type AnnotationFilterEndEnhancerArgs = {
  iconStyles?: AnnotationFilterIconStyles;
};
type AnnotationFilterOption = SearchOptionWithIcon;
export interface AnnotationFilterProps {
  annotationCount: number;
  title: string;
  selectedFilter: string | undefined;
  placeholder?: string;
  endEnhancer?: (args?: AnnotationFilterEndEnhancerArgs) => React.ReactNode;
  filterOptions?: AnnotationFilterOption[];
  onFilterChange?: (value: string) => void;
}
export const AnnotationFilter = ({
  annotationCount,
  title,
  selectedFilter,
  endEnhancer,
  filterOptions,
  onFilterChange,
  placeholder
}: AnnotationFilterProps) => {
  const [css, theme] = useStyletron();
  const selectedOption = filterOptions?.find(filter => selectedFilter === filter.value);
  return <div className={css({
    gap: theme.sizing.scale600,
    display: 'flex',
    flexDirection: 'column'
  })}>
      <ListItem hasDivider={false} overrides={{
      ...listItemOverrides,
      Root: {
        style: {
          paddingTop: 0
        }
      }
    }}>
        <LabelMedium margin={0}>{`${title} (${annotationCount})`}</LabelMedium>
        {endEnhancer && endEnhancer({
        iconStyles: {
          size: 14
        }
      })}
      </ListItem>
      {filterOptions && filterOptions.length > 0 && <>
          <Select value={selectedOption && [selectedOption]} options={filterOptions} onChange={params => {
        onFilterChange?.(params.value[0]?.value);
      }} placeholder={placeholder} labelKey="label" valueKey="value" size={SelectSize.compact} type={SelectType.search} overrides={filterOptionOverrides} getOptionLabel={option => <RenderSearchOptionLabel {...(option.option as AnnotationFilterOption)} />} />
        </>}
    </div>;
};